module.exports = __webpack_public_path__ + "img/share_label_left.e6f0a29d.png";